// import Swal from 'sweetalert2/dist/sweetalert2.js'
// import 'sweetalert2/src/sweetalert2.scss'
 
import Swal from "sweetalert2";

export function toastEmmit(type, msg) {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
    showCloseButton: true
  });

  Toast.fire({
    icon: type,
    title: msg,
  });
}

export function showSuccessAlert(message, callback) {
  Swal.fire({
    title: "Success!",
    text: message,
    icon: "success",
    confirmButtonColor: "#6986e6",
    confirmButtonText: "Ok",
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });
}

export function showWarningAlert(callback) {
  Swal.fire({
    title: "Are you sure you want to cancel this order?",
    text: "You won't be able to revert this!",
    // icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#1f4ce0",
    cancelButtonColor: "#d33",
    cancelButtonText: "Close",
    confirmButtonText: "Yes, Cancel it!",
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    padding: '40px 0px',
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });
}

export function OrderPlacedAlert(toDetail, toHome, to) {
  Swal.fire({
    title: "Thank you for ordering!",
    text: "Payment received & your order placed successfully!",
    imageUrl: "assets/img/breadcrumb/success-print.svg",
    imageWidth: '100%',
    imageHeight: 160,
    imageAlt: "Custom image",
    showCancelButton: true,
    confirmButtonColor: "#1f4ce0",
    cancelButtonColor: "#7c9aff",
    cancelButtonText: "Back to Home",
    confirmButtonText: "View Order",
    allowOutsideClick: false,
    customClass: {
      title: 'swal2-title-padding'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      console.log(to)
      toDetail(to)
    }
    else if (result.dismiss === Swal.DismissReason.cancel) {
      toHome()
    }
  });
}

export function SessionExpiredAlert(callback) {  
    Swal.fire({
      title: "Session Expired",
      text: "Please login again to continue services",
      icon: "info",
      confirmButtonColor: "#1f4ce0",
      confirmButtonText: "Close",
      allowOutsideClick: false,
      padding: '40px 0px',
    }).then((result) => {
      if (result.isConfirmed) {
        callback();
      }
    }); 
 
}
 
export function showGuestUserExistAlert(callback) {
  Swal.fire({
    title: "Duplicate Contact Details Detected",
    text: "The email or phone number you entered is already registered. Please update the details or log in with the existing account to continue.",
    // icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#1f4ce0",
    cancelButtonColor: "#6d6d6d",
    cancelButtonText: "Update",
    confirmButtonText: "Login with account!",
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    padding: '40px 0px',
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });
}